// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LLgp","title":"styles_title__1FcLm"};